import PreRegisterApi from './rest/PreRegisterApi';

export default new PreRegisterApi();
